/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { Component } from 'react';
import { connect } from 'react-redux';

import SearchWorkCardRedesign from 'js/canonical_cards/work_card/search_work_card_redesign';
import { ResearchInterest } from 'js/liswp/types';
import {
  loadWorkShareSuggestions,
  fetchActorData,
  reportWork,
  followUser,
  unfollowUser,
  requestJoinSession,
  addToLibrary,
  removeFromLibrary,
  fetchResearchInterestFollowerCount,
  followResearchInterest,
  unfollowResearchInterest,
  // @ts-expect-error yes that file is untyped
} from 'js/redux_store/search_results/actions';
import { BulkDownloadFilterCounts } from 'js/bulk_download/bulk_download_helper';
import User from 'js/core_post_webpack/models/user';
import { currentUser } from 'js/utils/user';

export type Author = {
  id: number;
  department?: {
    name: string;
    university: {
      name: string;
    };
  };
  displayName: string;
  url?: string; // Optional for ownerless works with external authors
  photo?: string;

  // Loaded async by fetchActorData
  followerCount?: number;
  viewCount?: number;
  workCount?: number;
  isFollowing?: boolean;
};

// From work_card.wjs.jsx prop type
export interface Work {
  id: number;
  title: string;
  internalUrl: string;
  authors: Author[];
  downloadableAttachments: {
    downloadUrl: string;
    id: number;
    scribdThumbnailUrl: string;
  }[];
  metadata: {
    abstract: string;
    publicationDate?: {
      day: number;
      month: number;
      year: number;
    };
    publicationName?: string;
  };
  researchInterests: ResearchInterest[];
  highlight?: {
    title: string[];
    'attachments.text': string[];
    query: string;
  };
  structured_highlight?: {
    type: string;
    content: string;
  }[];
  showFullTextUpsell?: boolean;
  isBookmarked?: boolean;
  paperRank?: number;
  percentile?: string;
  views?: number;
  alreadySharedUserIds?: any[];
  shareSuggestions?: any[];
  missingTerms?: string[];
  filterCounts?: BulkDownloadFilterCounts;
  citationCount?: number;
}

interface Props {
  showStats?: boolean;
  works: Work[];
  premium: boolean;
  researchInterests: {
    [id: number]: ResearchInterest;
  };
  actors: {
    [id: number]: Author;
  };

  showFullTextUpsell?: boolean; // Yes, this is also in the work type

  loadWorkShareSuggestions: any;
  reportWork: any;
  addToLibrary: any;
  removeFromLibrary: any;
  fetchActorData: any;
  followUser: any;
  unfollowUser: any;
  fetchResearchInterestFollowerCount: any;
  followResearchInterest: any;
  unfollowResearchInterest: any;
  requestJoinSession: any;
}

interface State {
  SearchResults: {
    researchInterests: {
      [id: number]: ResearchInterest;
    };
    actors: {
      [id: number]: Author;
    };
  };
}

class CanonicalWorkResults extends Component<Props, State> {
  render() {
    const { works, premium, researchInterests, actors } = this.props;

    works.forEach((work) => {
      // merge async ri data with the ri data existing in work objects
      work.researchInterests = work.researchInterests.map((ri) => ({
        ...ri,
        ...researchInterests[ri.id],
      }));

      // merge async author data with the author data existing in work objects
      work.authors = work.authors.map((author) => ({
        ...author,
        ...actors[author.id],
      }));
    });

    return (
      <div className="a-fadeInDown">
        {works &&
          works.map((work, i) => {
            const hasBulkDownload = Boolean(
              work.downloadableAttachments[0]?.downloadUrl,
            );

            return (
              <div key={`paper_${i}`}>
                <SearchWorkCardRedesign
                  work={work}
                  premium={premium}
                  source="search-results"
                  loadWorkShareSuggestions={this.props.loadWorkShareSuggestions}
                  reportWork={this.props.reportWork}
                  addToLibrary={this.props.addToLibrary}
                  removeFromLibrary={this.props.removeFromLibrary}
                  fetchActorData={this.props.fetchActorData}
                  followUser={this.props.followUser}
                  unfollowUser={this.props.unfollowUser}
                  fetchResearchInterestFollowerCount={
                    this.props.fetchResearchInterestFollowerCount
                  }
                  followResearchInterest={this.props.followResearchInterest}
                  unfollowResearchInterest={this.props.unfollowResearchInterest}
                  showBulkDownloadButton={hasBulkDownload}
                  showBulkDownloadModal={hasBulkDownload && !premium}
                  loggedIn={!!(User?.current || currentUser)}
                />
              </div>
            );
          })}
      </div>
    );
  }
}

const mapStateToProps = (state: State) => {
  const { actors, researchInterests } = state.SearchResults;
  return {
    actors,
    researchInterests,
  };
};
const mapDispatchToProps = {
  reportWork,
  loadWorkShareSuggestions,
  addToLibrary,
  removeFromLibrary,
  fetchActorData,
  followUser,
  unfollowUser,
  requestJoinSession,
  fetchResearchInterestFollowerCount,
  followResearchInterest,
  unfollowResearchInterest,
};

// Redux export is unused
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CanonicalWorkResults);

// Not connected to redux store
export { CanonicalWorkResults as DisconnectedCanonicalWorkResults };
